import React from "react";
import { arrayMap } from "../../../../utils/array.utils";
import SubCardTitle from "../../../../components/styled/SubCardTitle";

export default function VehicleCustomerRequirementViewCard({ data, title }) {
  return (
    <div className="card border-0" style={{ height: `100%` }}>
      <div className="card-body">
        <SubCardTitle>{title ?? ""}</SubCardTitle>
        <ul className="list-unstyled mb-0">
          {arrayMap(data, (item, index) => (
            <li key={index}>
              <span style={{ fontWeight: 500 }}>{item.label}: </span>
              {item.value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
